namespace $ { $mol_style_attach( "mol/button/major/major.view.css",
 "[mol_button_major] {\n\tbackground-color: var(--mol_theme_back);\n\tcolor: var(--mol_theme_text);\n}\n"
) }